import { CommonUtility } from '@utility/common';
import { APIPath } from '@utility/constants/api';
import { BaseService } from './base';
import { CRUDService } from './crud';
import type { OrderShippingLabelsResponse } from '@skupreme/api-contracts/core';

class ShippingLabel extends CRUDService {
  constructor() {
    super(APIPath.shippingLabel);
  }

  getLabels(orderId: string): Promise<OrderShippingLabelsResponse> {
    return BaseService.get(`${APIPath.shippingOrderLabel}/${orderId}`);
  }

  operation(requestId: string) {
    return BaseService.get(
      `${APIPath.shippingLabel}/operations/${encodeURIComponent(requestId)}`,
    );
  }

  metadata() {
    return BaseService.get(`${APIPath.shippingLabelMetadata}`);
  }

  fulfillmentProviders(orderId, queryParams) {
    const params = CommonUtility.objectToParams(queryParams);
    return BaseService.get(
      `${APIPath.shippingLabelOrderFulfill}/${orderId}?${params}`,
    );
  }

  orderFulfillMetadata(orderId) {
    return BaseService.get(
      `${APIPath.shippingLabelOrderFulfill}/${orderId}/metadata`,
    );
  }

  rate(reqData, signal?: AbortSignal) {
    return BaseService.post(
      APIPath.shippingLabelRate,
      reqData,
      false,
      true,
      '',
      signal,
    );
  }

  print(data) {
    return BaseService.post(`${APIPath.shippingLabelPrint}`, data);
  }

  generateReturnLabel(data) {
    return BaseService.post(`${APIPath.generateReturnLabel}`, data);
  }

  refund(labelId) {
    return BaseService.remove(`${APIPath.shippingLabelRefund}/${labelId}`);
  }

  orderFulfill(data) {
    return BaseService.post(`${APIPath.shippingLabelOrderFulfill}`, data);
  }

  addressValidation(data) {
    return BaseService.post(APIPath.shippingLabelAddressValidation, data);
  }

  fetchShippingLabelsManualShipOrder(orderId, data) {
    return BaseService.post(
      [APIPath.shippingLabelOrderShip, orderId, 'ship'].join('/'),
      data,
    );
  }

  checkOrderScan(code) {
    return BaseService.get(`${APIPath.shippingLabelScan}/${code}`);
  }

  getProviderHighestAlias(data) {
    return BaseService.post(APIPath.fulfillmentProviderFetchAlias, data);
  }
}

const ShippingLabelService = new ShippingLabel();
Object.freeze(ShippingLabelService);
export default ShippingLabelService;
